import {mapActions, mapGetters, mapMutations} from "vuex";
import moment from "moment";
import newDesignSwitch from "@/mixins/newDesignSwitch";

export default {
    name    : 'profile-tooltip',
    mixins  : [newDesignSwitch],
    computed: {
        ...mapGetters({
            user                : `user/user`,
            userTariff          : `user/userTariff`,
            certificates        : `userSertificates/list`,
            openNotification    : "userPayments/openNotification"
        }),
        imgAvatar() {
            if (this.user) return this.user.personalData.data.avatar !== '' ? this.user.personalData.data.avatar : require('@/assets/img/default-avatar.jpg')
            return require('@/assets/img/default-avatar.jpg')
        }
    },
    created() {
        if (!this.certificates || this.certificates.length === 0) {
            this.fetchCertificates();
        }
    },
    methods: {
        ...mapMutations({
            changeShowTooltip: `header/HEADER_PROFILE_SHOW_TOOLTIP`,
        }),
        ...mapActions({
            fetchCertificates: 'userSertificates/GET_LIST',
            authLogout: 'auth/AUTH_LOGOUT'
        }),
        calculateExpiredDate(item) {
            const {activeTo} = item;
            
            if (!activeTo) {
                return '∞'
            }
            
            return moment(activeTo).format('DD MMMM, YYYY')
        },
        logout() {
            this.authLogout();

            this.$router.push({name: 'sing-in'})
        },
    }
}
